const notifyWhenAvailableButton = document.getElementById(
  "notifyWhenAvailableButton"
);
const notifyWhenAvailableForm = document.querySelector("#notifyWhenAvailableForm");

function handleNotifyWhenAvailable(event) {
  event.preventDefault();

  const form = notifyWhenAvailableForm;
  const emailInput = form.querySelector("#notify-email");
  const emailField = emailInput.closest(".field");
  const emailError = form.querySelector("#notify-email-error");
  const emailPermission = form.querySelector("#notify-emailPerm");
  const emailPermissionLabel = form.querySelector('[for="notify-emailPerm"]');
  const productId = form.querySelector("#productId").value;
  const variantId = form.querySelector("#variantId").value;
  const email = emailInput.value.trim();
  let hasError = false;

  emailField.dataset.error = "false";
  emailError.textContent = "";
  emailPermissionLabel.dataset.error = "false";

  if (!email || !emailInput.validity.valid) {
    emailField.dataset.error = "true";
    emailError.textContent = "E-posta adresiniz geçerli değil.";
    hasError = true;
  }

  if (!emailPermission.checked) {
    emailPermissionLabel.dataset.error = "true";
    hasError = true;
  }

  if (hasError) {
    return;
  }

  window.mnm.eventBus.dispatchEvent(
    new CustomEvent("alarms_add", { detail: { productId, variantId, email } })
  );

  document.dispatchEvent(new KeyboardEvent('keyup', {key: 'escape', code: 'escape'})); 
  window.mnm.snackbar("Bilgilendirme talebiniz başarıyla alındı. Ürün stoğa girdiğinde size haber vereceğiz.", "success")
  document.querySelector('#ModalClose-outOfStock').click()
}

if (notifyWhenAvailableButton && notifyWhenAvailableForm) {
  notifyWhenAvailableButton.addEventListener("click", handleNotifyWhenAvailable);
  notifyWhenAvailableForm.addEventListener("submit", handleNotifyWhenAvailable);
}
